import Vue from 'vue'
import router from './router'

export default {

    // User object will let us check authentication status
    user: {
        authenticated: false,
        name: '',
        id: '',
        type: '',
        roles: [],
        courses: [],
        courses_coordinator: [],
        courses_exam_coordinator: []
    },

    // Send a request to the login URL and save the returned JWT
    login(context, creds, redirect, callback) {

        var headers = {
            headers: {'Access-Control-Allow-Origin': '*'},
            crossDomain: true
        };

        context.$http.post('login', creds).then(response => {
            localStorage.setItem('access_token', response.data.jwt)            
            let jwt = this.getJWTData()
            localStorage.setItem('userid', jwt.data.userid)
            localStorage.setItem('username', jwt.data.username)
            localStorage.setItem('usertype', jwt.data.usertype)
            localStorage.setItem('userroles', JSON.stringify(jwt.data.userroles))
            localStorage.setItem('usercourses', JSON.stringify(jwt.data.usercourses))
            localStorage.setItem('usercourses_teacher', JSON.stringify(jwt.data.usercourses_teacher))
            localStorage.setItem('usercourses_coursecoordinator', JSON.stringify(jwt.data.usercourses_coursecoordinator))
            localStorage.setItem('usercourses_examcoordinator', JSON.stringify(jwt.data.usercourses_examcoordinator))

            this.user.authenticated = true
            this.user.type = jwt.data.usertype
            this.user.id = jwt.data.userid
            this.user.name = jwt.data.username            
            this.user.roles = jwt.data.userroles
            this.user.courses = jwt.data.usercourses
            this.user.courses_teacher = jwt.data.usercourses_teacher
            this.user.courses_coordinator = jwt.data.usercourses_coursecoordinator
            this.user.courses_exam_coordinator = jwt.data.usercourses_examcoordinator

            Vue.http.headers.common['Authorization'] = this.getAuthHeader()

            if (typeof callback === 'function') {
                callback()
            }
            // Redirect to a specified route
            if (redirect) {
                // Students and visitors must be redirected to exam schedule instead of about page
                if (redirect == '/' && !this.user.roles.includes('evaluator')) {
                    redirect = '/cronograma'
                }
                router.push(redirect)
            }

        }, response => {
            let error = ''
            switch (response.status) {
                case 400:
                    error = 'Erro ao se conectar com o servidor'
                    break
                case 401:
                    error = 'A senha informada está incorreta'
                    break
                case 402:
                    error = 'Número máximo de tentativas excedido. Aguarde alguns minutos e tente novamente.'
                    break
                case 403:
                    error = 'Você não tem acesso a este sistema.'
                    break                                      
                case 404:
                    error = 'O código de usuário informado não existe'
                    break                    
                default:
                    error = response.status + ' ' + JSON.stringify(response.body)
                    break
            }
            context.error = error
        })
    },

    // To log out, we just need to remove the token
    logout() {
        localStorage.removeItem('access_token')
        localStorage.removeItem('userid')
        localStorage.removeItem('username')
        localStorage.removeItem('usertype')
        localStorage.removeItem('userroles')
        localStorage.removeItem('usercourses')
        localStorage.removeItem('usercourses_teacher')
        localStorage.removeItem('usercourses_coursecoordinator')
        localStorage.removeItem('usercourses_examcoordinator')
        this.user.authenticated = false
        delete Vue.http.headers.common['Authorization']
        router.push('/entrar')
    },

    checkAuth() {
        var jwt = localStorage.getItem('access_token')        
        if (jwt && !this.JWTExpired()) {
            this.user.authenticated = true
            this.user.id = localStorage.getItem('userid')
            this.user.name = localStorage.getItem('username')
            this.user.type = localStorage.getItem('usertype')
            this.user.roles = JSON.parse(localStorage.getItem('userroles'))
            this.user.courses = JSON.parse(localStorage.getItem('usercourses'))
            this.user.courses_teacher = JSON.parse(localStorage.getItem('usercourses_teacher'))
            this.user.courses_coordinator = JSON.parse(localStorage.getItem('usercourses_coursecoordinator'))
            this.user.courses_exam_coordinator = JSON.parse(localStorage.getItem('usercourses_examcoordinator'))
        } else {
            this.user.authenticated = false
        }
    },

    // The object to be passed as a header for authenticated requests
    getAuthHeader() {
        return 'Bearer ' + localStorage.getItem('access_token')
    },

    getJWTData() {
        let jwt = localStorage.getItem('access_token')
        return JSON.parse(window.atob(jwt.split('.')[1]))
    },

    JWTExpired() {
        return this.getJWTData().exp < (Math.floor(Date.now() /1000))
    }
}


// WEBPACK FOOTER //
// ./src/auth.js